import { AxiosRequestConfig } from 'axios';
import { Configuration as AtlantisConfiguration } from '../openapi/atlantis';
import { Configuration as DropboxConfiguration } from '../openapi/dropbox';
import { Configuration as KeymakerConfiguration } from '../openapi/keymaker';
import { Configuration as LeoConfiguration } from '../openapi/leo';
import { Configuration as SherlockConfiguration } from '../openapi/sherlock';
import { Configuration as SignatureConfiguration } from '../openapi/signature-api';
import { Configuration as YadaConfiguration } from '../openapi/yada';
import { Configuration as YentaConfiguration } from '../openapi/yenta';
import config from '../config';
import CampaignService from '../services/CampaignService';
import { getAuthCookie } from './AuthUtils';

const getBaseOptions = (): AxiosRequestConfig => {
  const headers: Record<string, string> = {
    'X-real-app-name': 'one-real-web',
    'X-real-app-version': config.deployVersion,
  };

  // Add campaign header if campaign is active
  const campaign = CampaignService.getCampaign();
  if (campaign) {
    headers['X-rezen-campaign'] = campaign;
  }

  return { headers };
};

export const getKeymakerConfiguration = async () =>
  new KeymakerConfiguration({
    accessToken: getAuthCookie(),
    basePath: config.apiBasePath.keymaker,
    baseOptions: getBaseOptions(),
  });

export const getAtlantisConfiguration = async () =>
  new AtlantisConfiguration({
    accessToken: getAuthCookie(),
    basePath: config.apiBasePath.atlantis,
    baseOptions: getBaseOptions(),
  });

export const getDropboxConfiguration = async () =>
  new DropboxConfiguration({
    accessToken: getAuthCookie(),
    basePath: config.apiBasePath.dropbox,
    baseOptions: getBaseOptions(),
  });

export const getYadaConfiguration = async () =>
  new YadaConfiguration({
    accessToken: getAuthCookie(),
    basePath: config.apiBasePath.yada,
    baseOptions: getBaseOptions(),
  });

export const getYentaConfiguration = async () =>
  new YentaConfiguration({
    accessToken: getAuthCookie(),
    basePath: config.apiBasePath.yenta,
    baseOptions: getBaseOptions(),
  });

export const getSherlockConfiguration = async () =>
  new SherlockConfiguration({
    accessToken: getAuthCookie(),
    basePath: config.apiBasePath.sherlock,
    baseOptions: getBaseOptions(),
  });

export const getSignatureApiConfiguration = () =>
  new SignatureConfiguration({
    accessToken: getAuthCookie(),
    basePath: config.apiBasePath.signature,
    baseOptions: getBaseOptions(),
  });

export const getLeoConfiguration = () =>
  new LeoConfiguration({
    accessToken: getAuthCookie(),
    basePath: config.apiBasePath.leo,
    baseOptions: getBaseOptions(),
  });
